/*
 * @Author: WLL
 * @Date: 2020-04-29 14:06:28
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-01 12:49:11
 * @Description: 研报详情页面接口
 */
import http from "@/utils/http";

export default {
  async getReportDetail(params) {
    return await http.post("base/report_detail", params);
  }
};
